export const colors = {
    DARK_GREEN: '#00A59B',
    IDLE_INDICATOR: '#B9D1CD',
    CONTAINER_BG: '#F5F5F5',
    ACTION_GREEN: '#9BA570',
    DARK_TEXT: '#282A2D',
    LIGHT_GREY: '#F5F5F5',
    LIGHT_GREEN_TEXT: '#A5B2BB', // Same as info icon
    CANCEL_TEXT: '#FF3F57',
    ACTION_BAR: '#FBE3E6',
    NAV_BAR: '#504f5c',
    NAV_BAR_BTN: '#6a6874',
    DARK_BACKGROUND: 'rgba(40, 42, 45, 0.85)',
    HALF_WHITE: 'rgba(255,255,255,0.5)',
    MEDIUM_GREY: '#E2E2E2',
    WHITE: '#FFF',
    MEDIUM_GRAY_TEXT: 'rgba(74,74,74,0.5)',
    LIGHT_BORDER: '#E5E5E5',
    DARK_GREY: '#00000022',
    LIGHT_BLUE: '#4fb5ff',
    PURPLE_DARKER: '#292830',
    PURPLE_DARK: '#3e3d47',
    COMMENT_ODD: '#635f6b',
    COMMENT_EVEN: '#6a6874',
    ORANGE: '#ff8040',
};



// WEBPACK FOOTER //
// ./src/styles/colors.ts